/**
 * Check if remote database mode is enabled
 */
export const isRemoteDatabaseEnabled = (): boolean => {
  return import.meta.env.VITE_DATABASE_MODE === 'remote';
};

/**
 * Get Supabase configuration
 */
export const getSupabaseConfig = () => {
  if (!isRemoteDatabaseEnabled()) {
    return null;
  }
  
  return {
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY
  };
};


/**
 * Log analytics event
 */
export const logAnalytics = async (action: string, data: any = {}): Promise<void> => {
  const event = {
    id: `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    action,
    timestamp: new Date().toISOString(),
    data
  };
  
  if (isRemoteDatabaseEnabled()) {
    // TODO: Implement Supabase analytics logging
    console.log('Remote database mode: Analytics would be sent to Supabase', event);
    return;
  }
  
  // In local mode, just console log the event
  console.log('Analytics Event:', event);
};
